'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugMode = false;

try {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var debugI18n = urlParams.get('debugI18n');
    if (debugI18n === 'nolang') {
        debugMode = true;
    }
} catch (e) {}

var i18n = {

    impl: null,
    wixImpl: null,

    get: function get(token1, token2, params) {

        if (debugMode) {
            return token1;
        }

        params = (0, _extends3.default)({}, params, { decoration: {
                italicStart: '<i>',
                italicEnd: '</i>'
            } });

        if (typeof window !== 'undefined' && window.__I18N_DEBUG__) {
            try {
                var value = i18n.wixImpl.get(token1, '', params);;

                var parsed = {
                    value: value,
                    token: token1,
                    params: params,
                    english: token2,
                    ok: !!value
                };

                value = '__I18N__' + btoa(encodeURIComponent((0, _stringify2.default)(parsed))) + '__I18N__';

                return value;
            } catch (e) {}
        }

        if (!i18n.impl) {
            if (!i18n.wixImpl) return '';
            return i18n.wixImpl.get(token1, token2, params);;
        }
        return i18n.impl.get(token1, token2, params);
    },
    getWithLink: function getWithLink(token, fallback, mapLink, params) {
        var result = i18n.get(token, fallback, (0, _extends3.default)({
            link: { begin: '####', end: '####' }
        }, params));

        var splitted = result.split('####');

        return splitted.map(function (str, idx) {
            return idx % 2 === 0 ? str : mapLink(str);
        });
    },
    getWithNLink: function getWithNLink(token, fallback, mapLinkArray, params) {
        var result = i18n.get(token, fallback, (0, _extends3.default)({
            link: { begin: '####', end: '####' }
        }, params));

        var splitted = result.split('####');

        return splitted.map(function (str, idx) {
            return idx % 2 === 0 ? str : mapLinkArray[Math.floor(idx / 2)](str);
        });
    },
    getLocale: function getLocale() {
        if (!i18n.impl) return null;
        return i18n.impl.getLocale();
    },
    getFacebookLanguage: function getFacebookLanguage() {
        if (!i18n.impl) return null;
        return i18n.impl.getFacebookLanguage();
    },
    getGoogleLanguage: function getGoogleLanguage() {
        if (!i18n.impl) return null;
        return i18n.impl.getGoogleLanguage();
    },
    getDir: function getDir() {
        if (!i18n.impl) return null;
        return i18n.impl.getDir();
    },
    isRtlDir: function isRtlDir() {
        if (!i18n.impl) return false;
        return i18n.impl.isRtlDir();
    },
    getLanguage: function getLanguage() {
        if (!i18n.impl) return null;
        return i18n.impl.getLanguage();
    },
    getWixI18n: function getWixI18n() {
        return i18n.wixImpl;
    },
    getComponentHeader: function getComponentHeader(prefix) {
        var I18N = function I18N(token, english, params) {
            return i18n.get(prefix + token, english, params);
        };

        var I18N_COMMON = function I18N_COMMON(token, params) {
            return i18n.get('openrest_common_' + token, '', params);
        };

        var I18N_NOPREFIX = function I18N_NOPREFIX(token, english, params) {
            var rc = i18n.get(token, english, params);
            return rc;
        };

        var I18N_EXTERNAL = function I18N_EXTERNAL(token, params) {
            return i18n.get(token, '', params);
        };

        var I18N_UGSTR = function I18N_UGSTR(localized, defaultLocale) {
            var localize = function localize(obj) {
                return _lodash2.default.chain(obj).at(defaultLocale, i18n.getLocale() /* TODO, organizationLocale*/).compact().head().value();
            };

            return (_lodash2.default.isArray(localized) ? localize(_lodash2.default.find(localized, function (obj) {
                return localize(obj);
            })) : localize(localized)) || '';
        };

        return { i18n: i18n, I18N: I18N, I18N_COMMON: I18N_COMMON, I18N_NOPREFIX: I18N_NOPREFIX, I18N_EXTERNAL: I18N_EXTERNAL, I18N_UGSTR: I18N_UGSTR };
    }
};

exports.default = i18n;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/I18n.js
// module id = 145
// module chunks = 0